import type { components } from "@/lib/api/schema.gen";

/**
 * Domain type aliases for the questionnaire slice, sourced from the generated
 * OpenAPI schema so the UI stays in lockstep with the DRF serializers.
 */
type Schemas = components["schemas"];

export type Thematic = Schemas["Thematic"];
export type Issue = Schemas["Issue"];
export type Goal = Schemas["Goal"];
export type Action = Schemas["Action"];
export type Sector = Schemas["Sector"];
export type Characteristic = Schemas["Characteristic"];
export type CompanySize = Schemas["CompanySize"];

export type EnterpriseProfileDetail = Schemas["EnterpriseProfileDetail"];
export type EnterpriseProfileCreate = Schemas["EnterpriseProfileCreate"];

export type ActionAnswer = Schemas["ActionAnswer"];
export type AnswerType = Schemas["AnswerEnum"];

export type QuestionnaireStatus = Schemas["QuestionnaireStatus"];
export type QuestionnaireProgress = Schemas["QuestionnaireProgress"];
export type ThematicProgress = Schemas["ThematicProgress"];
export type IssueProgress = Schemas["IssueProgress"];
export type GoalProgress = Schemas["GoalProgress"];

export type ResultThematic = Schemas["ResultThematic"];
export type ResultIssue = Schemas["ResultIssue"];
export type ResultGoal = Schemas["ResultGoal"];
export type ResultAnswer = Schemas["ResultAnswer"];

export type UnavoidableIssue = Schemas["UnavoidableIssue"];
export type AvailableOptionalIssue = Schemas["AvailableOptionalIssue"];
export type OptionalIssueChoice = Schemas["OptionalIssueChoice"];

/** Editable enterprise-profile values shared by the create and edit forms. */
export interface ProfileFormValues {
  name: string;
  enterprise_type: string;
  address: string;
  city: string;
  zip_code: string;
  phone_number: string;
  website: string;
  email: string;
  description: string;
  sector_ids: string[];
  characteristic_ids: string[];
  /** "" means "not specified". */
  company_size_id: string;
}

export const EMPTY_PROFILE: ProfileFormValues = {
  name: "",
  enterprise_type: "",
  address: "",
  city: "",
  zip_code: "",
  phone_number: "",
  website: "",
  email: "",
  description: "",
  sector_ids: [],
  characteristic_ids: [],
  company_size_id: "",
};

/** The four steps of the self-diagnostic journey. */
export type QuestionnaireStep =
  | "identification"
  | "issues"
  | "answering"
  | "results";

/**
 * A step registers its autosave `flush` (or `null` on unmount) so the wizard can
 * persist pending edits before navigating away. See useAutosave's `flush`.
 */
export type FlushFn = () => Promise<void>;
export type RegisterFlush = (fn: FlushFn | null) => void;

/** The valid answer values (mirrors ActionAnswer.AnswerType on the backend). */
export const ANSWER_VALUES = {
  CarriedOut: "carried_out",
  CourseOfAction: "course_of_action",
  NotApplicable: "not_applicable",
} as const satisfies Record<string, AnswerType>;
